import styled from "@emotion/styled";
import { FlexRow, H2, List } from "atoms";
import { useReviewsByBadge } from "../api/useReviewsByBadge";
import { ReviewCard } from "./ReviewCard";

type CollectiveReviewsProps = {
  id: string;
  name: string;
};

function CollectiveReviews({ id, name }: CollectiveReviewsProps) {
  const { data, isError } = useReviewsByBadge(id);
  const reviews = data?.data ?? [];
  if (data?.totalResults === 0 || isError) {
    return null;
  }

  return (
    <>
      <FlexRow flexDirection="column" alignItems="center" gap="0">
        <H2 size="lg" id="reviews">
          Latest Reviews of {name} Artists
        </H2>
      </FlexRow>
      <ReviewGrid>
        {reviews.map((review) => (
          <ReviewCard review={review} key={review.reviewId} />
        ))}
      </ReviewGrid>
    </>
  );
}

const ReviewGrid = styled(List)(({ theme }) => ({
  position: "relative",
  display: "grid",
  gap: theme.spacing.gap,
  gridTemplateColumns: "100%",
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: `repeat(2, 1fr)`,
  },
  [theme.breakpoints.desktopLarge]: {
    gridTemplateColumns: `repeat(3, 1fr)`,
  },
  "&>li:nth-of-type(n+7)": {
    display: "none",
  },
  // "&::before": {
  //   content: "''",
  //   position: "absolute",
  //   display: "block",
  //   width: "55vw",
  //   height: "55vw",
  //   maxWidth: 700,
  //   maxHeight: 700,
  //   right: `calc(${theme.spacing.gutter} * -1)`,
  //   top: 0,
  //   backgroundColor: theme.colors.accent2LL,
  //   borderRadius: theme.borderRadius.round,
  //   transform: "translate(0, -6rem)",
  //   zIndex: -1,
  // },
}));
ReviewGrid.defaultProps = {
  type: "blank",
};

export { CollectiveReviews };
